import { render } from "./List.vue?vue&type=template&id=a8b4d020"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./List.vue?vue&type=style&index=0&id=a8b4d020&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__